export function normalizeApiBaseUrl(url: string | undefined) {
  const normalizedUrl = url?.trim().replace(/\/+$/, "");

  if (!normalizedUrl) {
    throw new Error("API_URL이 설정되지 않았습니다. 배포 환경의 빌드 변수를 확인하세요.");
  }

  return normalizedUrl;
}
